var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggle-section",class:{
    'toggle-section--transition': _vm.transition,
    'toggle-section--overflow-hidden': _vm.transitioning || !_vm.expanded,
  },style:(`height: ${_vm.height};`)},[_c('div',{ref:"section",attrs:{"inert":!_vm.expanded}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }